import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import swipe from '@ts/utils/alpine-swipe-plugin';


window.Alpine = Alpine;

Alpine.plugin(focus);
Alpine.plugin(swipe);

